<template>
  <v-container fluid color="white--text">
    <v-card elevation="5">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-card flat>
              <v-card-title>Check Transaction Status</v-card-title>
              <v-card-text>
                <p>
                  As a merchant, you need to check the status of the transaction to confirm that the payment was successful before completing the transaction. For every transaction, you must supply the Checkout Request ID. To request payment you need to make a POST call to the following url
                </p>
              </v-card-text>
              <v-divider/>
              <v-divider/>
              <v-card-text>
                EndPoints:<br/>
                <div class="secondary pa-5" style="color: #e7e3fc">
                  <strong>Sandbox</strong>
                  <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/transactions/status/"}}</p>
                </div>
              </v-card-text>
              <v-card-text>
                Request Parameters <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>MerchantCode</code>  <br/>
                <v-icon color="primary">mdi-access-point-check</v-icon> <code>CheckoutRequestId</code>  <br/>
              </v-card-text>
              <v-divider/>
              <v-card-text>
                Expected Results:<br/>

                Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="">
            <h3>Sample Request</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                @lang="changeLanguage"
                v-model="code"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['php','PHP'],['python', 'Python'],['java','Java'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
            ></code-editor>
            <v-divider/>
            <h3>Sample Response</h3>
            <code-editor
                :read_only="true"
                theme="dark"
                v-model="response"
                :wrap_code="false"
                :language_selector="true"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['json','JSON']]"
            ></code-editor>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import {
  queryStatusRequest,
  queryStatusResponse
} from "../../../../../shared/snippets/c2b/processPayment";

export default {
  name: "Authentications",
  // components: { VueStylelintEditor },
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
  }),
  mounted() {
    this.importPaymentStatusRequest('php')//
    this.importResponse()
  },
  methods:{
    importPaymentStatusRequest(lang){
      this.code=queryStatusRequest(lang)
    },
    importResponse(){
      this.response=queryStatusResponse()
    },
    changeLanguage(val){
      this.importPaymentStatusRequest(val)
    }
  }
}
</script>

<style scoped>

</style>